import styled from "styled-components";
import { Container } from "../../styles/Container";

export const Wrapper = styled.div`
  margin: 5rem auto;

  ${Container}
`;

export const Content = styled.div`
  width: 100%;
  padding: 1rem 0;
  h1 {
    font-size: 4rem;
  }
  .stack {
    font-size: 14px;
  font-weight: 300;
  }

  .description, .text {
    text-align: justify;
    font-size: 1rem;
  }
`;
